import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useOfflineStore = create(
  persist(
    (set, get) => ({
      isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
      pendingSyncCount: 0,
      lastSyncedAt: null,
      syncInProgress: false,

      setOnline: () => set({ isOnline: true }),
      setOffline: () => set({ isOnline: false }),

      incrementPending: (count = 1) =>
        set((state) => ({ pendingSyncCount: state.pendingSyncCount + count })),

      decrementPending: (count = 1) =>
        set((state) => ({
          pendingSyncCount: Math.max(0, state.pendingSyncCount - count)
        })),

      setPendingSyncCount: (count) => set({ pendingSyncCount: count }),

      setSyncInProgress: (inProgress) => set({ syncInProgress: inProgress }),

      setLastSyncedAt: (timestamp) =>
        set({ lastSyncedAt: timestamp || new Date().toISOString() })
    }),
    {
      name: 'offline-storage',
      partialize: (state) => ({
        pendingSyncCount: state.pendingSyncCount,
        lastSyncedAt: state.lastSyncedAt
      })
    }
  )
);
